import { merge, pick } from 'lodash-es';

function prepareMainConfig(originMainConfig, extraMainConfig) {
  const pickedMainConfig = pick(merge({}, originMainConfig, extraMainConfig), [
    'currencyData',
    'currentPath',
    'currentUser',
    'env',
    'features',
    'featuresLimit',
    'isExceedCartLimitation',
    'isMultiCurrencyEnabled',
    'isRecaptchaEnabled',
    'localeData',
    'merchantData',
    'merchantId',
    'promotionExcludedHints',
    'recaptchaSiteKey',
    'requestCountry',
    'sessionId',
    'staticResourceHost',
    'webpSupported',
    'onePageStoreId',
    'shoplinePaymentV2Env',
    'userCreditRules',
    'memberPointRules',
  ]);

  pickedMainConfig.merchantData = pick(pickedMainConfig.merchantData, [
    '_id',
    'base_country_code',
    'base_currency_code',
    'base_currency',
    'beta_feature_keys',
    'brand_home_url',
    'checkout_setting',
    'enabled_stock_reminder',
    'handle',
    'mobile_logo_media_url',
    'name',
    'promotion_setting',
    'rollout_keys',
    'supported_languages',
    'user_setting',
    'order_setting',
    'invoice_activation',
    'sl_payment_merchant_id',
  ]);

  pickedMainConfig.merchantData.user_setting = pick(
    pickedMainConfig.merchantData.user_setting?.data,
    [
      'birthday_format',
      'custom_fields',
      'general_fields',
      'minimum_age_limit',
      'enable_age_policy',
      'enable_member_point',
      'enable_user_credit',
    ],
  );

  pickedMainConfig.merchantData.order_setting = pick(
    pickedMainConfig.merchantData.order_setting,
    ['custom_fields', 'no_duplicate_uniform_invoice', 'invoice'],
  );

  return pickedMainConfig;
}

export default prepareMainConfig;
